/**
 * Directory of valid `gamefroot-4` resource types.
 */
const ResourceTypes = {
  Resource: "Resource",
  Script: "Script",
  Dependent: "Dependent",
  Immutable: "Immutable",
  ImageFile: "ImageFile",
  AudioFile: "AudioFile",
  FontFile: "FontFile",
  Correlator: "Correlator",
  FolderLabel: "FolderLabel",
  FontFace: "FontFace",
  Game: "Game",
  JsonData: "JsonData",
  Level: "Level",
  Layer: "Layer",
  InstanceLayer: "InstanceLayer",
  TileLayer: "TileLayer",
  Tile: "Tile",
  TileSingle: "TileSingle",
  MagicTile16: "MagicTile16",
  MagicTile47: "MagicTile47",
  Instance: "Instance",
  SpriteInstance: "SpriteInstance",
  TextInstance: "TextInstance",
  Sprite: "Sprite",
  ScriptedSprite: "ScriptedSprite",
  Sequence: "Sequence",
  Frame: "Frame",
};

export default ResourceTypes;
